import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";

const SalesTrendChart = ({ data }) => {
  const { t } = useTranslation();
  const chartData =
    data?.map((item) => {
      const [date, value] = item.split(":");
      return {
        name: new Date(date).toLocaleDateString("tr-TR", {
          day: "2-digit",
          month: "2-digit",
        }),
        value: parseInt(value) || 0,
      };
    }) || [];

  const chartConfig = {
    value: {
      label: t("extendedWarranty.reports.salesTrend.count", "Adet"),
      color: "#10B981",
    },
  };

  return (
    <div className="mb-6 rounded-lg border bg-white p-6">
      <h3 className="mb-4 text-lg font-medium text-[#111729]">
        {t(
          "extendedWarranty.reports.salesTrend.title",
          "Zaman Bazlı Satış Trendi",
        )}
      </h3>
      <p className="mb-4 text-sm text-[#677389]">
        {t(
          "extendedWarranty.reports.salesTrend.description",
          "Günlük satış performansı",
        )}
      </p>
      <div className="h-64">
        {data && data.length > 0 ? (
          <ChartContainer config={chartConfig} className="h-full w-full">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 12 }}
                  tickLine={false}
                  axisLine={false}
                />
                <YAxis
                  tick={{ fontSize: 12 }}
                  tickLine={false}
                  axisLine={false}
                />
                <ChartTooltip content={<ChartTooltipContent />} />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#10B981"
                  strokeWidth={2}
                  dot={{ fill: "#10B981", strokeWidth: 2, r: 4 }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </ChartContainer>
        ) : (
          <div className="flex h-full items-center justify-center text-[#677389]">
            {t(
              "extendedWarranty.reports.common.loadingData",
              "Veri yükleniyor...",
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesTrendChart;
